import { useState, useEffect } from "react";
import {ApiUrl} from "../../ApiUrl"
const useFetchCountries = () => {
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  useEffect(() => {
    const fetchCountries = async () => {
      const apiURL = `${ApiUrl.apiurl}COUNTRY/GetAllCountry/`;
      try {
        const response = await fetch(apiURL);
        const result = await response.json();
        if (response.ok) {
          setCountries(Array.isArray(result?.data) ? result.data : []);
        } else {
          setError(result.message);
        }
      } catch (err) {
        setError("Failed to fetch countries");
        setCountries([]);
      } finally {
        setLoading(false);
      }
    };
    fetchCountries();
  }, []);
  return { countries, loading, error };
};
export default useFetchCountries;